import type { Tour } from "../types/index";

export const tours: Tour[] = [
  {
    id: 1,
    title: "North Island Explorer",
    region: "north-island",
    duration: 7,
    price: 1200,
    description:
      "Discover the stunning landscapes and rich culture of New Zealand's North Island. From Auckland's vibrant city life to Rotorua's geothermal wonders, this tour showcases the best of the North Island.",
    featuredImage: "/assets/IMG_9188+(2).JPG",
    heroImage: "/assets/auckland-viaduct.jpg",
    itinerary: [
      {
        dayNumber: 1,
        title: "Arrival in Auckland",
        activities: [
          { name: "Airport pickup" },
          { name: "Check in and orientation" },
          { name: "Explore Auckland city centre" },
          { name: "Visit Parnell Rose Garden" },
          { name: "Leisure walk at Mission Bay" },
        ],
      },
      {
        dayNumber: 2,
        title: "Auckland to Rotorua",
        activities: [
          { name: "Travel to Matamata (Hobbiton)" },
          { name: "Hobbiton Movie Set" },
          { name: "Lunch at a local restaurant" },
          { name: "Travel to Rotorua" },
          { name: "Stroll through Rotorua town centre" },
        ],
      },
      {
        dayNumber: 3,
        title: "Rotorua Day",
        activities: [
          { name: "Redwoods Forest walk" },
          { name: "Whakarewarewa Maori Village" },
          { name: "Lunch at a local restaurant" },
          { name: "Skyline Gondola Rotorua" },
        ],
      },
      {
        dayNumber: 4,
        title: "Rotorua to Taupo",
        activities: [
          { name: "Travel to Taupo" },
          { name: "Walk around Huka Falls" },
          { name: "Huka Jet adventure" },
          { name: "Arrival in Taupo" },
        ],
      },
      {
        dayNumber: 5,
        title: "Whakapapa Ski Field",
        activities: [
          { name: "Drive to Whakapapa Ski Field" },
          { name: "Ski field exploration" },
          { name: "Lunch at the ski resort" },
          { name: "Skiing / snowboarding time" },
          { name: "Drive back to Taupo" },
        ],
      },
      {
        dayNumber: 6,
        title: "Return to Auckland",
        activities: [
          { name: "Scenic drive to Auckland" },
          { name: "Lunch in Auckland" },
          { name: "Cornwall Park visit" },
          { name: "Free time" },
          { name: "Dinner at a local restaurant" },
        ],
      },
      {
        dayNumber: 7,
        title: "Auckland Day and Departure",
        activities: [
          { name: "Visit Westhaven Marina" },
          { name: "Auckland Museum" },
          { name: "Lunch at a local restaurant" },
          { name: "Free time" },
          { name: "Departure from New Zealand" },
        ],
      },
    ],
  },
  {
    id: 2,
    title: "South Island Adventure",
    region: "south-island",
    duration: 9,
    price: 1900,
    description:
      "Experience the dramatic landscapes of New Zealand's South Island. From Christchurch's charm to Queenstown's adventure capital, this tour highlights the scenic beauty of the South Island.",
    featuredImage: "/assets/queenstown-overview.jpg",
    heroImage: "/assets/hooker-valley-track.jpg",
    itinerary: [
      {
        dayNumber: 1,
        title: "Arrive in Auckland",
        activities: [{ name: "Arrive in Auckland" }],
      },
      {
        dayNumber: 2,
        title: "Auckland to Christchurch",
        activities: [
          { name: "Depart from Auckland to Christchurch" },
          { name: "City exploration" },
          { name: "Punting on the Avon River" },
          { name: "Free time" },
        ],
      },
      {
        dayNumber: 3,
        title: "Lake Tekapo & Twizel",
        activities: [
          { name: "Travel to Lake Tekapo" },
          { name: "Church of the Good Shepherd" },
          { name: "Tekapo to Twizel" },
          { name: "Twizel exploration" },
        ],
      },
      {
        dayNumber: 4,
        title: "Mount Cook to Wanaka",
        activities: [
          { name: "Sir Edmund Hillary Centre" },
          { name: "Mount Cook valley walk" },
          { name: "Scenic drive to Wanaka" },
          { name: "Lake Wanaka walk" },
        ],
      },
      {
        dayNumber: 5,
        title: "Wanaka to Queenstown",
        activities: [
          { name: "Journey to Queenstown" },
          { name: "Skyline Gondola" },
          { name: "Queenstown Gardens" },
        ],
      },
      {
        dayNumber: 6,
        title: "Queenstown Adventure Day",
        activities: [
          { name: "Explore Glenorchy" },
          { name: "Choose your adventure" },
        ],
      },
      {
        dayNumber: 7,
        title: "Te Anau and Milford Sound Day Trip",
        activities: [
          { name: "Travel to Te Anau" },
          { name: "Bus ride to Milford Sound" },
          { name: "Milford Sound cruise" },
          { name: "Return to Te Anau" },
          { name: "Free time" },
        ],
      },
      {
        dayNumber: 8,
        title: "Return to Queenstown",
        activities: [
          { name: "Te Anau to Queenstown" },
          { name: "Glenorchy day trip" },
          { name: "Free time in Queenstown" },
        ],
      },
      {
        dayNumber: 9,
        title: "Queenstown to Auckland and Departure",
        activities: [
          { name: "Airport transfer" },
          { name: "Flight to Auckland" },
          { name: "Farewell lunch" },
          { name: "Departure from New Zealand" },
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Combo Island Experience",
    region: "combo-island",
    duration: 16,
    price: 2500,
    description:
      "The complete New Zealand experience combining the best of both islands. From Auckland City to Milford Sound, this comprehensive tour showcases the country's incredible diversity of landscapes, culture and experiences.",
    featuredImage: "/assets/helicopter.jpg",
    heroImage: "/assets/lake-pukaki-aoraki-road.jpg",
    itinerary: [
      {
        dayNumber: 1,
        title: "Arrival in Auckland",
        activities: [{ name: "Airport meet and greet" }, { name: "Pick up vehicle" }, { name: "Auckland sightseeing" }, { name: "Check in Auckland accommodation" }],
      },
      {
        dayNumber: 2,
        title: "Auckland to Rotorua",
        activities: [
          { name: "Travel to Matamata (Hobbiton)" },
          { name: "Hobbiton Movie Set" },
          { name: "Lunch at a local restaurant" },
          { name: "Travel to Rotorua" },
          { name: "Stroll through Rotorua town centre" },
        ],
      },
      {
        dayNumber: 3,
        title: "Rotorua Day",
        activities: [
          { name: "Redwoods Forest walk" },
          { name: "Whakarewarewa Maori Village" },
          { name: "Lunch at a local restaurant" },
          { name: "Skyline Gondola Rotorua" },
        ],
      },
      {
        dayNumber: 4,
        title: "Rotorua to Taupo",
        activities: [
          { name: "Travel to Taupo" },
          { name: "Walk around Huka Falls" },
          { name: "Huka Jet adventure" },
          { name: "Arrival in Taupo" },
        ],
      },
      {
        dayNumber: 5,
        title: "Whakapapa Ski Field",
        activities: [
          { name: "Drive to Whakapapa Ski Field" },
          { name: "Ski field exploration" },
          { name: "Lunch at the ski resort" },
          { name: "Skiing / snowboarding time" },
          { name: "Drive back to Taupo" },
        ],
      },
      {
        dayNumber: 6,
        title: "Return to Auckland",
        activities: [
          { name: "Scenic drive to Auckland" },
          { name: "Lunch in Auckland" },
          { name: "Free time" },
        ],
      },
      {
        dayNumber: 7,
        title: "Fly to Christchurch",
        activities: [
          { name: "Flight to Christchurch" },
          { name: "Christchurch arrival" },
          { name: "City exploration" },
          { name: "Punting on the Avon River" },
        ],
      },
      {
        dayNumber: 8,
        title: "Lake Tekapo & Twizel",
        activities: [
          { name: "Travel to Lake Tekapo" },
          { name: "Church of the Good Shepherd" },
          { name: "Tekapo to Twizel" },
          { name: "Twizel exploration" },
        ],
      },
      {
        dayNumber: 9,
        title: "Mount Cook to Wanaka",
        activities: [
          { name: "Sir Edmund Hillary Centre" },
          { name: "Mount Cook valley walk" },
          { name: "Scenic drive to Wanaka" },
          { name: "Lake Wanaka walk" },
        ],
      },
      {
        dayNumber: 10,
        title: "Wanaka to Queenstown",
        activities: [
          { name: "Journey to Queenstown" },
          { name: "Skyline Gondola" },
          { name: "Queenstown Gardens" },
        ],
      },
      {
        dayNumber: 11,
        title: "Queenstown Adventure Day",
        activities: [
          { name: "Explore Glenorchy" },
          { name: "Choose your adventure" },
        ],
      },
      {
        dayNumber: 12,
        title: "Te Anau and Milford Sound Day Trip",
        activities: [
          { name: "Travel to Te Anau" },
          { name: "Bus ride to Milford Sound" },
          { name: "Milford Sound cruise" },
          { name: "Return to Te Anau" },
          { name: "Free time" },
        ],
      },
      {
        dayNumber: 13,
        title: "Return to Queenstown",
        activities: [
          { name: "Te Anau to Queenstown" },
          { name: "Free time in Queenstown" },
          { name: "Farewell lunch" },
        ],
      },
      {
        dayNumber: 14,
        title: "Queenstown to Auckland",
        activities: [
          { name: "Airport transfer" },
          { name: "Flight to Auckland" },
          { name: "Auckland farewell dinner" },
        ],
      },
      {
        dayNumber: 15,
        title: "Free Day in Auckland",
        activities: [
          { name: "Free exploration" },
          { name: "Farewell dinner" },
        ],
      },
      {
        dayNumber: 16,
        title: "Departure",
        activities: [{ name: "Airport transfer" }],
      },
    ],
  },
];
